
class Account {

    constructor(data) {
        this.populate(data);
    }

    populate(data) {
        data = data ? data : {};

        this.Company = (typeof data.Company !== 'undefined' && data.Company ? data.Company : null);
        this.ContactName = (typeof data.ContactName !== 'undefined' && data.ContactName ? data.ContactName : null);
        this.ContactPhone = (typeof data.ContactPhone !== 'undefined' && data.ContactPhone ? data.ContactPhone : null);
        this.Email = (typeof data.Email !== 'undefined' && data.Email ? data.Email : null);
        this.TimeZone = (typeof data.TimeZone !== 'undefined' && data.TimeZone ? data.TimeZone : 13);
        this.DaylightSavings = (typeof data.DaylightSavings !== 'undefined' && data.DaylightSavings ? data.DaylightSavings : null);
        this.UserName = (typeof data.UserName !== 'undefined' && data.UserName ? data.UserName : null);
        this.Password = (typeof data.Password !== 'undefined' && data.Password ? data.Password : null);
        this.DefaultLocation = (typeof data.DefaultLocation !== 'undefined' && data.DefaultLocation ? data.DefaultLocation : null);
        this.DefaultDestination = (typeof data.DefaultDestination !== 'undefined' && data.DefaultDestination ? data.DefaultDestination : null);
        // this.PageSize = (typeof data.PageSize !== 'undefined' && data.PageSize ? data.PageSize : 10);
        // this.StatusColors = (typeof data.StatusColors !== 'undefined' && data.StatusColors ? data.StatusColors : true);

        this.fieldErrors = {
            Company:            [],
            ContactName:        [],
            ContactPhone:       [],
            Email:              [],
            TimeZone:           [],
            DaylightSavings:    [],
            UserName:           [],
            Password:           [],
            DefaultLocation:    [],
            DefaultDestination: [],
            // PageSize:           [],
            // StatusColors:       [],
        };

        // this.requiredFields = {
        //     Company:            false,
        //     ContactName:        true,
        //     ContactPhone:       true,
        //     Email:              false,
        //     TimeZone:           false,
        //     DaylightSavings:    false,
        //     UserName:           true,
        //     Password:           true,
        //     DefaultLocation:    false,
        //     DefaultDestination: false,
        //     // PageSize:           false,
        //     // StatusColors:       false,
        // };

    }

}

module.exports = Account;